var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('section', {
    staticClass: "sub-visual"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap mb-24 mb-md-50 mb-lg-0"
  }, [_c('v-img', {
    staticClass: "tit-wrap__img",
    attrs: {
      "src": "/images/common/tit-img.png"
    }
  }), _c('h2', {
    staticClass: "tit tit--xl"
  }, [_vm._v(" Service ")])], 1)]), _c('v-img', {
    staticClass: "sub-visual__img",
    attrs: {
      "src": "/images/sub/service/sub-visual-service.jpg"
    }
  }), _c('sub-tab', {
    attrs: {
      "page": "고객센터",
      "tabActive": 2
    }
  })], 1), _c('section', {
    staticClass: "sub-section sub-section--notice"
  }, [_c('v-container', {
    staticClass: "font-pretendard"
  }, [!_vm.$route.params._notification ? _c('notification-list') : _c('notification-view')], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }